export default __webpack_public_path__ + "static/media/3D apparel visualization.c7a22f93.jpg";